/**
 * Part of eden40 project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */
import u from '@main';
import '@vendor/owl.carousel/dist/owl.carousel.min.js?2d869d7ab7d56ac3052db866';
import '@vendor/wowjs/dist/wow.min.js?2d869d7ab7d56ac3052db866';

u.importCSS('@vendor/owl.carousel/dist/assets/owl.carousel.min.css');
u.importCSS('@vendor/owl.carousel/dist/assets/owl.theme.default.min.css');
u.importCSS('@vendor/animate.css/animate.min.css');

$(() => {
  new WOW().init();
})

const menu = $('.c-thoseday .c-menu');
const menuBtn = $('.j-scroll-btn');

$(window).on('scroll', () => {
  let rect = $('.c-content')[0].getBoundingClientRect();

  if (window.innerHeight - rect.top > (window.innerHeight * 0.7)
    && (window.innerHeight - rect.bottom) <= (window.innerHeight - 750)) {

    if (menu.hasClass('hide')) {
      menu.removeClass('hide');
    }
  } else {
    if (!menu.hasClass('hide')) {
      menu.addClass('hide');
    }
  }

  menuBtn.each((e, i) => {
    activeMenu($(i).data('target'));
  });
});

menuBtn.on('click', (e) => {
  const $this = $(e.currentTarget);
  const target = $this.data('target');
  const wrapper = $this.parent();

  scrollTo(target);
});

function scrollTo(element) {
  $('html,body').animate({
    scrollTop: $(element).offset().top - ($('.c-header').height() + 50)
  }, 100);
}

function activeMenu(element) {
  let target = $(element);
  let rect = target[0].getBoundingClientRect();

  if (window.innerHeight - rect.top > (window.innerHeight * 0.5)
    && (window.innerHeight - rect.bottom) <= (window.innerHeight - 750)) {

    menuBtn.removeClass('active');

    let menu = '.j-scroll-btn[data-target = "' + element + '"]';

    $(menu).addClass('active');
  }
}

//thoseday carousel
const thoseDay = $('.c-thoseday');
const thoseDayOwl = $('.c-thoseday .j-slider-carousel .owl-carousel');
const preBtn = thoseDay.find('.j-prev');
const nextBtn = thoseDay.find('.j-next');

thoseDayOwl.owlCarousel({
  items: 1,
  loop: true,
  nav : false,
  dots: true,
  dotsData: true,
  autoplay: true,
  autoplayTimeout: 6000,
  autoplayHoverPause: true,
  slideTransition: 'linear'
});

$(() => {
  setTimeout(() => {
    $('.target-1').find('.c-item__bg').addClass('rotate');
  }, 2000);
});

thoseDayOwl.on('changed.owl.carousel', function(e) {
  $('.c-item__bg').removeClass('rotate');

  $('.target-' + (e.page.index + 1)).find('.c-item__bg').addClass('rotate');
});

preBtn.on('click', function () {
  thoseDayOwl.trigger('prev.owl.carousel');
});

nextBtn.on('click', function () {
  thoseDayOwl.trigger('next.owl.carousel');
});
